var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.08 20H5.91C2.38 20 0 17.729 0 14.34V5.67C0 2.28 2.38 0 5.91 0H14.08C17.62 0 20 2.28 20 5.67V14.34C20 17.729 17.62 20 14.08 20ZM12.27 9.25H5.92C5.5 9.25 5.17 9.59 5.17 10C5.17 10.42 5.5 10.75 5.92 10.75H12.27L9.79 13.22C9.65 13.36 9.57 13.56 9.57 13.75C9.57 13.939 9.65 14.13 9.79 14.28C10.08 14.57 10.56 14.57 10.85 14.28L14.62 10.53C14.9 10.25 14.9 9.75 14.62 9.47L10.85 5.72C10.56 5.43 10.08 5.43 9.79 5.72C9.5 6.02 9.5 6.49 9.79 6.79L12.27 9.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.993d6c2d9205e3a16a43a700a8320462.svg";
export { ForwardRef as ReactComponent };